import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import {
  FormGroupDirective,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { AppSettingService } from '@rd/core/services/app-setting/app-setting.service';
import { LoyaltyProgram } from '@rd/types';

@Component({
  selector: 'rd-membership-detail-form',
  templateUrl: './membership-detail-form.component.html',
  styleUrls: ['./membership-detail-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MembershipDetailFormComponent implements OnInit {
  @HostBinding('class.appearance-outline') get isAppearanceOutline(): boolean {
    return this.matFormFieldAppearance === 'outline';
  }

  @Input() formGroupName: string;
  @Input() loyaltyProgram: LoyaltyProgram;
  @Input() isEmailForm = false;

  membershipDetailForm: UntypedFormGroup;
  matFormFieldAppearance: MatFormFieldAppearance =
    this.appSettingService.matFormFieldAppearance;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private appSettingService: AppSettingService,
  ) {}

  ngOnInit(): void {
    this.membershipDetailForm = this.rootFormGroup.control.get(
      this.formGroupName,
    ) as UntypedFormGroup;
  }

  private get membershipNumber(): UntypedFormControl {
    return this.membershipDetailForm.get(
      'membershipNumber',
    ) as UntypedFormControl;
  }

  private get firstName(): UntypedFormControl {
    return this.membershipDetailForm.get('firstName') as UntypedFormControl;
  }

  private get lastName(): UntypedFormControl {
    return this.membershipDetailForm.get('lastName') as UntypedFormControl;
  }

  get isMembershipNumberInvalid(): boolean {
    return this.membershipNumber.hasError('membershipNumberInvalid');
  }

  get membershipNumberValidationPending(): boolean {
    return this.membershipNumber.pending;
  }

  get isMembershipNumberEmpty(): boolean {
    return this.membershipNumber.hasError('required');
  }

  get isFirstNameEmpty(): boolean {
    return this.firstName.hasError('required');
  }

  get firstNameIsInvalid(): boolean {
    return this.firstName.hasError('pattern');
  }

  get isLastNameEmpty(): boolean {
    return this.lastName.hasError('required');
  }

  get lastNameIsInvalid(): boolean {
    return this.lastName.hasError('pattern');
  }
}
